/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    /* Guard the header itself, not just the burger: this file is concatenated
       into one script, so a throw here would take down the navigation, the
       roster filter and the contact form with it. */
    if (!navigation) return;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.setAttribute('aria-expanded', 'false');

    burger.addEventListener('click', function () {
        const open = !navigation.classList.contains('is-open');
        navigation.classList.toggle('is-open', open);
        document.documentElement.style.overflowY = open ? 'hidden' : null;
        /* The button controls a panel; without this it silently lies about
           its own state to anyone using a screen reader. */
        burger.setAttribute('aria-expanded', String(open));
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Fold "Parent › Child" navigation labels into two-level dropdowns.
   Runs before Source's overflow menu below, because grouping ~30 entries into
   4 headings is what makes the menu fit in the first place. */
(function () {
    ismNavigation();
    ismNavGroups();
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items.
   Skipped once grouping applied: Source's version measures widths and pushes
   the overflow into a "..." button, which would tear the groups apart. */
(function () {
    if (document.querySelector('.gh-navigation-menu .nav.is-grouped')) return;
    dropdown();
})();

/* Filter practitioner rosters by specialty */
(function () {
    ismFilter();
})();

/* Contact form submit */
(function () {
    ismContact();
})();

/* Fade sections up as they enter the viewport */
(function () {
    ismReveal();
})();

/* Hero: parallax on the photograph, and the title word by word */
(function () {
    ismHeroMotion();
})();

/* Count the home page's four figures up when they arrive */
(function () {
    ismCounters();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();